export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/practice_card_1-5a7f2d79024dbb26712a204808c1d82d.svg";